<template>
  <div class="settings-wrapper">
    <div class="settings">
      <email class="card" cardTitle="Billing" :tableData="billingList" :flag="1" @getDetail="getDetail" />
      <email class="card" cardTitle="Audit" :tableData="auditList" :flag="2" @getDetail="getDetail" />
      <!-- <div class="flex flex-row w-1/2 mt-4">
        <p class="header">Control Accepted Barge</p>
        <el-switch v-model="controlAcceptedBarge" active-color="#13ce66" @change="handleControlAcceptedBargeChange" />
      </div>
      <div class="flex flex-row w-1/2 mt-2">
        <p class="header">Control Co Load</p>
        <el-switch v-model="controlCoload" active-color="#13ce66" @change="handleCoload" />
      </div> -->
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { getSystemEmail } from "@/services/form"
import email from "./component/email.vue";
import { controlAcceptedBarge, getAcceptedBarge } from "@/services/user";
export default {
  name: "Settings",
  components: { email },
  data() {
    return {
      params: {
        pageNum: 1,
        pageSize: 9999,
      },
      billingList: [],
      auditList: [],
      controlAcceptedBarge: false,
      controlCoload: false,
    }
  },
  computed: {
    ...mapState(["userInfo", "screenType"]),
    isMobileScreen() {
      return this.screenType?.isMobileScreen ?? false;
    },
    isAdmin() {
      return this.userInfo?.userType === 0 && this.userInfo?.role === 0;
    }
  },
  async created() {
    await this.getDetail()
  },
  methods: {
    async getDetail() {
      this.loading = true
      await getSystemEmail(this.params).then(res => {
        if (res.data) {
          this.billingList = res?.data["billing"]
          this.auditList = res?.data["audit"]
        }
      }).finally(() => {
        this.loading = false
      });
      await getAcceptedBarge().then(res => {
        if (res.data) {
          this.controlAcceptedBarge = res.data.controlAcceptedBargeNomination;
          this.controlCoload = res.data.enableCoLoad;
        }
      })
    },
    async handleControlAcceptedBargeChange(value) {
      try {
        await this.$confirm(
          `Are you sure you want to ${value ? 'enable' : 'disable'} Control Accepted Barge?`,
          {
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            type: 'warning',
            closeOnClickModal: false,
          }
        );
        try {
          await controlAcceptedBarge({
            controlAcceptedBargeNomination: value,
            enableCoLoad: this.controlCoload
          }).then(async res => {
            this.$message.success('Update accepted barge setting successfully');
            await this.getDetail();
          });
        } catch (error) {
          this.$message.error('Failed to update Control Accepted Barge setting');
          this.controlAcceptedBarge = !value;
        }
      } catch (e) {
        this.controlAcceptedBarge = !value;
        return;
      }
    },
    async handleCoload(value) {
      try {
        await this.$confirm(
          `Are you sure you want to ${value ? 'enable' : 'disable'} coload?`,
          {
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            type: 'warning',
            closeOnClickModal: false,
          }
        );
        try {
          await controlAcceptedBarge({
            controlAcceptedBargeNomination: this.controlAcceptedBarge,
            enableCoLoad: value
          }).then(async res => {
            this.$message.success('Update co load setting successfully');
            await this.getDetail();
          });
        } catch (error) {
          this.$message.error('Failed to update Control Accepted Barge setting');
          this.controlAcceptedBarge = !value;
        }
      } catch (e) {
        this.controlAcceptedBarge = !value;
        return;
      }
    }
  }
}
</script>
<style scoped lang="scss">
.settings {
  padding: 20px 20px;
  background-color: #ffffff;
  border-radius: 10px;
  height: calc(100vh - 90px);
  overflow-y: auto;
  display: flex;
  flex-direction: column;

  .card {
    flex: 1;
    overflow: hidden;
  }
}

.header {
  width: 100%;
  background: #ffffff;
  border-radius: 0px;
  height: 50px;
  color: #4c565c;
  font-weight: 700;
  font-size: 15px;
}
</style>
